import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Router
import { Link } from 'react-router-dom';

class QuestionsChangeStatus extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      question_id: this.props.question_id,
      active: this.props.active,
      url: this.props.url,
      class: '',
    };

    this.trocarActive = this.trocarActive.bind(this);
  }

  componentDidMount() {
    if (this.state.active == 1) {
      this.setState({class: 'btn btn-sm btn-success'});
    } else {
      this.setState({class: 'btn btn-sm btn-danger'});
    }
  }

  trocarActive () {
    var toggle = this.state.active;
    if (toggle === 1) {
      toggle = 0;
    } else {
      toggle = 1;
    }
    var datasave = {
      id: this.state.question_id,
      active: toggle,
    };
    var confirmacao = window.confirm('Tem certeza que deseja mudar o status dessa questão?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/questao/change_status', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if (toggle === 1) {
              self.setState({class: 'btn btn-sm btn-success'});
              self.setState({active: toggle});
            } else {
              self.setState({class: 'btn btn-sm btn-danger'});
              self.setState({active: toggle});
            }
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Link className={'btn btn-primary btn-sm'} to={this.state.url}>
    <i className="fa fa-fw fa-pencil"></i>
  </Link>&nbsp;
  <button onClick={this.trocarActive} className={this.state.class} alt="Trocar para desativado" title="Trocar para desativado"><i className="fa fa-fw fa-power-off"></i></button>
</div>
    );
  }
}

export default QuestionsChangeStatus;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/QuestionsChangeStatus.js